export default "__VITE_ASSET__DwurdkFb__"